module.exports = __webpack_public_path__ + "static/president-1260b08aef841e14e0e99a71e19bca8c.jpg";